import React, {Component} from 'react';
import RegistrationRequestForm from "./RegistrationRequestForm";
import {submitRegistration} from "../../requests/RegistrationRequests";
import {Link} from "react-router-dom";

class RegistrationRequestPage extends Component {
  render() {
    return (
      <div className={"container mt-5"}>
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mx-auto">
              <RegistrationRequestForm submit={submitRegistration}/> 
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-12 text-center">
            <Link to={"/login"}>
              <span className="button-back-text">Go To Login</span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

RegistrationRequestPage.propTypes = {};

export default RegistrationRequestPage;
